import { Button, styled } from '@mui/material';

export const DefaultButton = styled(Button)`
  flex: 1;
  height: 44px;
  border-radius: 16px;
  box-shadow: none;
  background-color: #fff !important;
  text-transform: none;
`;
